import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { DatePicker } from '@material-ui/pickers';
import { withStyles, FormHelperText, Fab, Grid } from '@material-ui/core';
import { Search as SearchIcon } from '@material-ui/icons';

class StatsDatePicker extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        fromDate: PropTypes.instanceOf(Date).isRequired,
        fromDateLimitMessage: PropTypes.string.isRequired,
        refreshFunc: PropTypes.func.isRequired,
        onFromDateChange: PropTypes.func.isRequired,
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { classes, fromDate, fromDateLimitMessage, refreshFunc, onFromDateChange } = this.props;
        return (
            <Grid container direction="row" justify="center" alignItems="center">
                <Grid container item sm={12} md={6} lg={3} xl={2} justify="center" alignItems="center" direction="column">
                    <DatePicker
                        className={classes.datePicker}
                        id="fromDate"
                        variant="inline"
                        label={Translator.translate('general.fromDate')}
                        value={fromDate}
                        format="dd MMMM yyyy"
                        disableFuture
                        autoOk
                        onChange={onFromDateChange}
                        aria-describedby="fromDate-error-text"
                    />

                    {fromDateLimitMessage && (
                        <FormHelperText className={classes.errorDatePicker} id="fromDate-error-text">
                            {fromDateLimitMessage}
                        </FormHelperText>
                    )}
                </Grid>

                <Grid container item sm={12} lg={3} xl={2} justify="center" alignItems="center" container>
                    <Fab variant="extended" size="medium" color="primary" aria-label="search" className={classes.searchButton} onClick={refreshFunc}>
                        <SearchIcon className={classes.searchIcon} />
                        {Translator.translate('general.table.toolbar.searchTooltip')}
                    </Fab>
                </Grid>
            </Grid>
        );
    }
}

const styles = theme => ({
    datePicker: {
        margin: 5,
    },
    searchIcon: {
        marginRight: 10,
    },
    searchButton: {
        marginTop: 10,
        marginBottom: 20,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    errorDatePicker: {
        marginTop: 5,
        // marginBottom: 15,
        color: theme.palette.error.main,
    },
});

export default withStyles(styles, { withTheme: true })(StatsDatePicker);



// WEBPACK FOOTER //
// ./data/components/StatsDatePicker.js